export const DEFAULT_PRICING_TABLE = [
    [{ label: 'Employer Profile', type: 'boolean' }, true, true, true],
    [{ label: 'Unlimited Job Posts', type: 'boolean' }, true, true, true],
    [{ label: 'Dedicated Customer Team', type: 'boolean' }, true, true, true],
    [{ label: 'Customer Articles', type: 'boolean' }, true, true, true],
    [
        { label: 'Fairygodboss Email Feature', type: 'boolean' },
        true,
        true,
        true,
    ],
    [{ label: 'Social Promotion', type: 'boolean' }, true, true, true],
    [{ label: 'Virtual Career Fairs', type: 'string' }, '0', '1', '2'],
    [{ label: 'Dedicated Email', type: 'boolean' }, false, true, true],
    [{ label: 'Job Board Ad', type: 'boolean' }, false, true, true],
    [
        { label: 'Webinar OR Instagram Takeover', type: 'boolean' },
        false,
        true,
        true,
    ],
    [{ label: 'Job Board Takeover', type: 'boolean' }, false, true, true],
    [{ label: 'Podcast Speaker', type: 'boolean' }, false, false, true],
];
